// extracted by mini-css-extract-plugin
export default {"container":"UserMultiSelectField_container__Wmu2T","avatar":"UserMultiSelectField_avatar__AKl9B"};